"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4954 2.5155C15.8139 5.2073 17.3424 6.8121 20 6.983v3.0275c-1.5402.148-2.8892-.3472-4.4582-1.2805v5.6625c0 7.1933-7.9787 9.4411-11.1864 4.2852-2.0612-3.3178-.799-9.1395 5.8132-9.3729v3.1926c-.5037.0796-1.0422.2048-1.5343.37-1.4707.4894-2.3045 1.4056-2.0729 3.0218.4459 3.0958 6.2243 4.012 5.7437-2.0374V2.5212h3.1903v-.0057z"
  })];
};

exports.default = _default;